export default __webpack_public_path__ + "static/media/8939.f9ceeee3.svg";